import script from "./ModuleManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ModuleManagement.vue?vue&type=script&setup=true&lang=js"

import "./ModuleManagement.vue?vue&type=style&index=0&id=ca204006&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca204006"]])

export default __exports__